import { Component, OnInit, AfterViewInit } from '@angular/core'; // Import AfterViewInit
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import AOS from 'aos'; // Import AOS

@Component({
  selector: 'app-blog-covers',
  imports: [CommonModule, RouterModule],
  standalone: true,
  templateUrl: './blog-covers.component.html',
  styleUrl: './blog-covers.component.scss'
})
export class BlogCoversComponent implements OnInit, AfterViewInit {
  blogs: any[] = [
    // {
    //   title: '10 Best AI Coding Tools for Developers in 2026',
    //   image: '../../../../assets/resources/blog/data-visualization-skills-2026/cover-card-img.jpg',
    //   postedOn: new Date('2026-01-24'),
    //   timeToRead: '10 Minute Read',
    //   navLink: '/tech-blogs/ai-coding-tools-for-developers'
    // },
    {
      title: 'Top 10 Data Visualization Skills You Need in 2026 to Stay Ahead of AI',
      image: '../../../../assets/resources/blog/data-visualization-skills-2026/cover-card-img.jpg',
      postedOn: new Date('2026-04-24'),
      timeToRead: '10 Minute Read',
      navLink: '/tech-blogs/data-visualization-skills-2026'
    },
    {
      title: 'The Autonomous Machine Revolution - Machine Agency, the Machine-to-Machine Economy, and the Future of Work',
      image: '../../../../assets/resources/blog/autonomous-machine-revolution/cover-card-img.jpg',
      postedOn: new Date('2026-01-24'),
      timeToRead: '15 Minute Read',
      navLink: '/tech-blogs/autonomous-machine-revolution'
    },
    {
      title: 'Rise of AI Agents in Enterprises: How Human-Centric Approach Drives Success',
      image: '../../../../assets/resources/blog/rise-of-ai-agents-card.png',
      postedOn: new Date('2025-11-28'),
      timeToRead: '15 Minute Read',
      navLink: '/tech-blogs/ai-agents-in-enterprises'
    },
    {
      title: 'Agentic AI in SDLC: How It Transforms Full-Stack Development in Multi-Cloud Ecosystems',
      image: '../../../../assets/resources/blog/agentic-ai-in-sdlc-card.png',
      postedOn: new Date('2025-09-26'),
      timeToRead: '10 Minute Read',
      navLink: '/tech-blogs/agentic-ai-in-sdlc'
    },
    {
      title: 'Top 10 Things to Know Before Implementing AGI in Your Business (2025 Guide)',
      image: '../../../../assets/resources/blog/agi-card.png',
      postedOn: new Date('2025-08-21'),
      timeToRead: '15 Minute Read',
      navLink: '/tech-blogs/agi-implementation-guide'
    },
    {
      title: 'RAG Chatbots Explained: How Retrieval-Augmented Generation is Reshaping AI Conversations',
      image: '../../../../assets/resources/blog/ai-blog-rag.webp',
      postedOn: new Date('2025-06-30'),
      timeToRead: '10 Minute Read',
      navLink: '/tech-blogs/rag-chatbot'
    },
    {
      title: 'Artificial General Intelligence (AGI): The Future of AI and Intelligent Agents',
      image: '../../../../assets/resources/blog/blog-rag.webp',
      postedOn: new Date('2025-05-30'),
      timeToRead: '10 Minute Read',
      navLink: '/tech-blogs/artificial-general-intelligence-agi'
    },
    {
      title: 'The 7 Best AI Tools for Project Management in 2025',
      image: '../../../../assets/resources/blog/da-bi.webp',
      postedOn: new Date('2025-04-22'),
      timeToRead: '10 Minute Read',
      navLink: '/tech-blogs/aitools-project-management'
    },
    {
      title: '4 SIMPLE STEPS TO BUILD A WEBSITE USING AI TOOLS',
      image: '../../../../assets/resources/blog/websitebuild-card.webp',
      postedOn: new Date('2025-04-08'),
      timeToRead: '10 Minute Read',
      navLink: '/tech-blogs/build-website-ai-tools'
    },
    {
      title: 'A COMPREHENSIVE GUIDE TO AGENTIC AI: COMPONENTS, IMPLEMENTATION, AND EXAMPLES',
      image: '../../../../assets/resources/blog/agentic-card.webp',
      postedOn: new Date('2025-01-28'),
      timeToRead: '7 Minute Read',
      navLink: '/tech-blogs/agentic-ai'
    },
    {
      title: 'Everything You Need to Know About iOS 18: Key Updates and Features',
      image: '../../../../assets/resources/blog/iosupdate-card.webp',
      postedOn: new Date('2024-12-03'),
      timeToRead: '7 Minute Read',
      navLink: '/tech-blogs/ios-updates'
    },
    {
      title: 'The Ultimate Guide to DevOps: From Evolution to Implementation',
      image: '../../../../assets/resources/blog/devops-guide-card.webp',
      postedOn: new Date('2024-10-01'),
      timeToRead: '7 Minute Read',
      navLink: '/tech-blogs/devops-guide'
    },
    {
      title: 'Why do you need Custom Web Development : A Complete Guide',
      image: '../../../../assets/resources/blog/web-cover-card.webp',
      postedOn: new Date('2024-03-29'),
      timeToRead: '7 Minute Read',
      navLink: '/tech-blogs/custom-web-development'
    },
    {
      title: 'Kalpita Data Obfuscation Tool for Secured Data',
      image: '../../../../assets/resources/blog/cover-obf-card.webp',
      postedOn: new Date('2024-02-28'),
      timeToRead: '7 Minute Read',
      navLink: '/tech-blogs/data-obfuscation'
    },
    {
      title: '7 Challenges Stopping Your Digital Transformation [Solutions Included]',
      image: '../../../../assets/resources/blog/digital-transformation-card.png',
      postedOn: new Date('2024-01-04'),
      timeToRead: '15 Minute Read',
      navLink: '/tech-blogs/digital-challenges'
    },
    {
      title: 'Ready to Digitize Your Business Process? Here’s What You Need To Know',
      image: '../../../../assets/resources/blog/digital-challenges-card.png',
      postedOn: new Date('2023-07-18'),
      timeToRead: '15 Minute Read',
      navLink: '/tech-blogs/digital-transformation'
    },
    {
      title: '10 Key Benefits of Business Process Automation with custom software',
      image: '../../../../assets/resources/blog/business-process-card.png',
      postedOn: new Date('2022-12-26'),
      timeToRead: '10 Minute Read',
      navLink: '/tech-blogs/business-process-automation'
    },
    {
      title: 'Comprehensive guide to software requirement analysis',
      image: '../../../../assets/resources/blog/software-reqanalysis.png',
      postedOn: new Date('2022-09-22'),
      timeToRead: '4 Minute Read',
      navLink: '/tech-blogs/software-requirement-analysis'
    }
  ];

  constructor(private router: Router) { }

  ngOnInit(): void {
    // Component initialization
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      AOS.init();
      AOS.refresh();
    }, 1000);
  }

  nav(url: any): void {
    this.router.navigateByUrl(url);
  }
}